import firebase from "firebase/app";

const state = {
  doctor: {},
  active_gamers_stat: {},
  error: null
};

const getters = {
  getDoctor(state) {
    return state.doctor;
  },
  getActiveGamersStat(state) {
    return state.active_gamers_stat;
  },
  getDoctorError(state) {
    return state.error;
  },
  getDoctorMessages(state) {
    var messages = state.doctor.messages;
    messages = messages.filter(x => x !== null);
    return messages;
  }
};

const mutations = {
  setDoctor(state, payload) {
    state.doctor = payload;
  },
  setActiveGamersStat(state, payload) {
    state.active_gamers_stat = payload;
  },
  setError(state, payload) {
    state.error = payload;
  }
};

const actions = {
  async updateDoctor({ commit }, doctor) {
    try {
      await firebase
        .database()
        .ref(`/doctors`)
        .child(doctor.id)
        .update(doctor);
    } catch (e) {
      commit("setError", e);
      throw e;
    }
  },

  async updateDoctorMessagesById({ commit }, { id, message_id, text, title }) {
    try {
      await firebase
        .database()
        .ref(`/doctors`)
        .child(id)
        .child("messages")
        .child(message_id)
        .update({ text, title });
    } catch (e) {
      commit("setError", e);
      throw e;
    }
  },

  async fetchDoctors({ commit }) {
    try {
      const doctors =
        (
          await firebase
            .database()
            .ref(`/doctors`)
            .once("value")
        ).val() || {};
      return Object.keys(doctors).map(key => ({ ...doctors[key], id: key }));
    } catch (e) {
      commit("setError", e);
      throw e;
    }
  },
  async deleteDoctor({ commit }, doctor) {
    try {
      await firebase
        .database()
        .ref(`/doctors`)
        .child(doctor.id)
        .remove()
        .then(() => {
          commit("setDoctor", null);
        })
        .catch(error => {
          commit("setError", error.message);
        });
    } catch (e) {
      commit("setError", e);
      throw e;
    }
  },
  async fetchDoctorById({ commit }, id) {
    return await firebase
      .database()
      .ref(`/doctors`)
      .child(id)
      .once("value", snapshot => {
        commit("setDoctor", snapshot.val());
      })
      .catch(error => {
        commit("setError", error);
      });
  },
  async fetchActiveGamersStatByDoctorId({ commit }, doctor_id) {
    firebase
      .database()
      .ref(`/doctors/${doctor_id}/active_gamers_stat`)
      .once("value", snapshot => {
        const returnArr = [];
        snapshot.forEach(function(childSnapshot) {
          const item = childSnapshot.val();
          returnArr.push(item);
        });
        commit("setActiveGamersStat", returnArr);
      })
      .catch(error => {
        commit("setError", error);
      });
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
